import "./EnrichPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const enrichData = [
  {
    title: "ENGLISH",
    items: ["Grammar", "Reading", "Writing", "Vocabulary","Video Lessons","Data Handling"],
  },
   {
    title: "SCIENCE",
    items: ["Physics", "Biology", "Video Lessons", "Chemistry","Video Lessons","Data Handling"],
  },
  {
    title: "MATHEMATICS",
    items: ["Numbers", "Addition", "Subtraction","Geometry","Video Lessons","Data Handling"],
  },
  {
    title: "EVS",
    items: ["Conservations", "Natural resources", "Environment","Human body","Video Lessons","Data Handling"],
  },
   {
    title: "HINDI",
    items: ["Listening", "Speaking", "Vocabulary","Writing","Video Lessons","Data Handling"],
  },
  {
    title: "SOCIAL",
    items: ["History", "Geography", "Civics","History","Video Lessons","Data Handling"],
  },
];

export default function EnrichPage() {
  return (
    <div className="enrichWrapper" style={{backgroundColor:"#bbe39f"}}>
      {enrichData.map((section) => (
        <div className="enrichColumn" key={section.title}>
          <div className="enrichHeading">
            <span className="enrichTitle">{section.title}</span>
          </div>

          <ul className="enrichList">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="enrichArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}